import * as React from "react";
import type { SVGProps } from "react";

interface IconProps extends SVGProps<SVGSVGElement> {
  fill?: string;
  isActive?: boolean;
}

export const DetailedIcon = ({
  fill = "black",
  isActive,
  ...restProps
}: IconProps) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 14 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="flex-grow-0 flex-shrink-0 w-6 h-6 relative"
    {...restProps}
  >
    <path
      d="M0.25 16.5859C0.250251 16.8096 0.339227 17.0241 0.497406 17.1823C0.655586 17.3405 0.870051 17.4294 1.09375 17.4297H12.9062C13.1299 17.4294 13.3444 17.3405 13.5026 17.1823C13.6608 17.0241 13.7497 16.8096 13.75 16.5859V2.52344C13.7497 2.29974 13.6608 2.08527 13.5026 1.92709C13.3444 1.76891 13.1299 1.67994 12.9062 1.67969H8.45072C8.45067 1.38134 8.33212 1.09522 8.12116 0.884254C7.91019 0.673288 7.62407 0.554743 7.32572 0.554688H6.67442C6.37607 0.554743 6.08995 0.673288 5.87898 0.884254C5.66802 1.09522 5.54947 1.38134 5.54942 1.67969H1.09375C0.870051 1.67994 0.655586 1.76891 0.497406 1.92709C0.339227 2.08527 0.250251 2.29974 0.25 2.52344V16.5859ZM6.23103 1.3335C6.28346 1.26593 6.3507 1.21129 6.42757 1.17378C6.50444 1.13628 6.58889 1.11692 6.67442 1.11719H7.32558C7.41106 1.11718 7.49542 1.13666 7.57225 1.17415C7.64907 1.21163 7.71635 1.26613 7.76896 1.3335C7.82156 1.40088 7.85813 1.47936 7.87586 1.56298C7.8936 1.6466 7.89204 1.73316 7.87131 1.81609L7.5709 3.0177C7.56053 3.05917 7.55975 3.10245 7.56861 3.14426C7.57748 3.18608 7.59575 3.22532 7.62206 3.25901C7.64836 3.2927 7.682 3.31996 7.72041 3.3387C7.75883 3.35745 7.80101 3.36719 7.84375 3.36719H10.0938C10.3174 3.36744 10.5319 3.45641 10.6901 3.61459C10.8483 3.77277 10.9372 3.98724 10.9375 4.21094V4.49219H3.0625V4.21094C3.06275 3.98724 3.15173 3.77277 3.30991 3.61459C3.46809 3.45641 3.68255 3.36744 3.90625 3.36719H6.15625C6.19899 3.36719 6.24117 3.35745 6.27959 3.3387C6.318 3.31996 6.35164 3.2927 6.37794 3.25901C6.40424 3.22532 6.42252 3.18608 6.43139 3.14426C6.44025 3.10245 6.43947 3.05917 6.4291 3.0177L6.12869 1.81609C6.10769 1.73319 6.106 1.64656 6.12374 1.5629C6.14148 1.47923 6.17819 1.40075 6.23103 1.3335ZM11.2188 5.05469C11.2933 5.05469 11.3649 5.02506 11.4176 4.97231C11.4704 4.91957 11.5 4.84803 11.5 4.77344V4.21094C11.5 4.11648 11.4906 4.02225 11.4717 3.92969H12.0625V15.7422H1.9375V3.92969H2.5283C2.50945 4.02225 2.49997 4.11648 2.5 4.21094V4.77344C2.5 4.84803 2.52963 4.91957 2.58238 4.97231C2.63512 5.02506 2.70666 5.05469 2.78125 5.05469H11.2188ZM0.8125 2.52344C0.812584 2.44887 0.842242 2.37738 0.894969 2.32466C0.947695 2.27193 1.01918 2.24227 1.09375 2.24219H5.65541L5.79604 2.80469H3.90625C3.68805 2.8047 3.47285 2.85554 3.27771 2.95318C3.08257 3.05082 2.91286 3.19256 2.78202 3.36719H1.65625C1.58166 3.36719 1.51012 3.39682 1.45738 3.44956C1.40463 3.50231 1.375 3.57385 1.375 3.64844V16.0234C1.375 16.098 1.40463 16.1696 1.45738 16.2223C1.51012 16.2751 1.58166 16.3047 1.65625 16.3047H12.3438C12.4183 16.3047 12.4899 16.2751 12.5426 16.2223C12.5954 16.1696 12.625 16.098 12.625 16.0234V3.64844C12.625 3.57385 12.5954 3.50231 12.5426 3.44956C12.4899 3.39682 12.4183 3.36719 12.3438 3.36719H11.218C11.0871 3.19256 10.9174 3.05082 10.7223 2.95318C10.5271 2.85554 10.312 2.8047 10.0938 2.80469H8.20396L8.34459 2.24219H12.9062C12.9808 2.24227 13.0523 2.27193 13.105 2.32466C13.1578 2.37738 13.1874 2.44887 13.1875 2.52344V16.5859C13.1874 16.6605 13.1578 16.732 13.105 16.7847C13.0523 16.8374 12.9808 16.8671 12.9062 16.8672H1.09375C1.01918 16.8671 0.947695 16.8374 0.894969 16.7847C0.842242 16.732 0.812584 16.6605 0.8125 16.5859V2.52344Z"
      className={`dark:${
        isActive ? "fill-primary" : "fill-caption group-hover:dark:fill-primary"
      }`}
      fill={fill}
    />
    <path
      d="M7 2.24219C7.15533 2.24219 7.28125 2.11627 7.28125 1.96094C7.28125 1.80561 7.15533 1.67969 7 1.67969C6.84467 1.67969 6.71875 1.80561 6.71875 1.96094C6.71875 2.11627 6.84467 2.24219 7 2.24219Z"
      className={`dark:${
        isActive ? "fill-primary" : "fill-caption group-hover:dark:fill-primary"
      }`}
      fill={fill}
    />
    <path
      d="M3.34375 7.30469C3.49908 7.30469 3.625 7.17877 3.625 7.02344C3.625 6.86811 3.49908 6.74219 3.34375 6.74219C3.18842 6.74219 3.0625 6.86811 3.0625 7.02344C3.0625 7.17877 3.18842 7.30469 3.34375 7.30469Z"
      className={`dark:${
        isActive ? "fill-primary" : "fill-caption group-hover:dark:fill-primary"
      }`}
      fill={fill}
    />
    <path
      d="M4.46875 7.30469H10.6562C10.7308 7.30469 10.8024 7.27506 10.8551 7.22231C10.9079 7.16957 10.9375 7.09803 10.9375 7.02344C10.9375 6.94885 10.9079 6.87731 10.8551 6.82456C10.8024 6.77182 10.7308 6.74219 10.6562 6.74219H4.46875C4.39416 6.74219 4.32262 6.77182 4.26988 6.82456C4.21713 6.87731 4.1875 6.94885 4.1875 7.02344C4.1875 7.09803 4.21713 7.16957 4.26988 7.22231C4.32262 7.27506 4.39416 7.30469 4.46875 7.30469Z"
      className={`dark:${
        isActive ? "fill-primary" : "fill-caption group-hover:dark:fill-primary"
      }`}
      fill={fill}
    />
    <path
      d="M3.34375 8.99219C3.49908 8.99219 3.625 8.86627 3.625 8.71094C3.625 8.55561 3.49908 8.42969 3.34375 8.42969C3.18842 8.42969 3.0625 8.55561 3.0625 8.71094C3.0625 8.86627 3.18842 8.99219 3.34375 8.99219Z"
      className={`dark:${
        isActive ? "fill-primary" : "fill-caption group-hover:dark:fill-primary"
      }`}
      fill={fill}
    />
    <path
      d="M4.46875 8.99219H10.6562C10.7308 8.99219 10.8024 8.96256 10.8551 8.90981C10.9079 8.85707 10.9375 8.78553 10.9375 8.71094C10.9375 8.63635 10.9079 8.56481 10.8551 8.51206C10.8024 8.45932 10.7308 8.42969 10.6562 8.42969H4.46875C4.39416 8.42969 4.32262 8.45932 4.26988 8.51206C4.21713 8.56481 4.1875 8.63635 4.1875 8.71094C4.1875 8.78553 4.21713 8.85707 4.26988 8.90981C4.32262 8.96256 4.39416 8.99219 4.46875 8.99219Z"
      className={`dark:${
        isActive ? "fill-primary" : "fill-caption group-hover:dark:fill-primary"
      }`}
      fill={fill}
    />
    <path
      d="M3.34375 10.6797C3.49908 10.6797 3.625 10.5538 3.625 10.3984C3.625 10.2431 3.49908 10.1172 3.34375 10.1172C3.18842 10.1172 3.0625 10.2431 3.0625 10.3984C3.0625 10.5538 3.18842 10.6797 3.34375 10.6797Z"
      className={`dark:${
        isActive ? "fill-primary" : "fill-caption group-hover:dark:fill-primary"
      }`}
      fill={fill}
    />
    <path
      d="M4.46875 10.6797H10.6562C10.7308 10.6797 10.8024 10.6501 10.8551 10.5973C10.9079 10.5446 10.9375 10.473 10.9375 10.3984C10.9375 10.3238 10.9079 10.2523 10.8551 10.1996C10.8024 10.1468 10.7308 10.1172 10.6562 10.1172H4.46875C4.39416 10.1172 4.32262 10.1468 4.26988 10.1996C4.21713 10.2523 4.1875 10.3238 4.1875 10.3984C4.1875 10.473 4.21713 10.5446 4.26988 10.5973C4.32262 10.6501 4.39416 10.6797 4.46875 10.6797Z"
      className={`dark:${
        isActive ? "fill-primary" : "fill-caption group-hover:dark:fill-primary"
      }`}
      fill={fill}
    />
    <path
      d="M3.34375 12.3672C3.49908 12.3672 3.625 12.2413 3.625 12.0859C3.625 11.9306 3.49908 11.8047 3.34375 11.8047C3.18842 11.8047 3.0625 11.9306 3.0625 12.0859C3.0625 12.2413 3.18842 12.3672 3.34375 12.3672Z"
      className={`dark:${
        isActive ? "fill-primary" : "fill-caption group-hover:dark:fill-primary"
      }`}
      fill={fill}
    />
    <path
      d="M4.46875 12.3672H10.6562C10.7308 12.3672 10.8024 12.3376 10.8551 12.2848C10.9079 12.2321 10.9375 12.1605 10.9375 12.0859C10.9375 12.0113 10.9079 11.9398 10.8551 11.8871C10.8024 11.8343 10.7308 11.8047 10.6562 11.8047H4.46875C4.39416 11.8047 4.32262 11.8343 4.26988 11.8871C4.21713 11.9398 4.1875 12.0113 4.1875 12.0859C4.1875 12.1605 4.21713 12.2321 4.26988 12.2848C4.32262 12.3376 4.39416 12.3672 4.46875 12.3672Z"
      className={`dark:${
        isActive ? "fill-primary" : "fill-caption group-hover:dark:fill-primary"
      }`}
      fill={fill}
    />
    <path
      d="M3.34375 14.0547C3.49908 14.0547 3.625 13.9288 3.625 13.7734C3.625 13.6181 3.49908 13.4922 3.34375 13.4922C3.18842 13.4922 3.0625 13.6181 3.0625 13.7734C3.0625 13.9288 3.18842 14.0547 3.34375 14.0547Z"
      className={`dark:${
        isActive ? "fill-primary" : "fill-caption group-hover:dark:fill-primary"
      }`}
      fill={fill}
    />
    <path
      d="M4.46875 14.0547H10.6562C10.7308 14.0547 10.8024 14.0251 10.8551 13.9723C10.9079 13.9196 10.9375 13.848 10.9375 13.7734C10.9375 13.6988 10.9079 13.6273 10.8551 13.5746C10.8024 13.5218 10.7308 13.4922 10.6562 13.4922H4.46875C4.39416 13.4922 4.32262 13.5218 4.26988 13.5746C4.21713 13.6273 4.1875 13.6988 4.1875 13.7734C4.1875 13.848 4.21713 13.9196 4.26988 13.9723C4.32262 14.0251 4.39416 14.0547 4.46875 14.0547Z"
      className={`dark:${
        isActive ? "fill-primary" : "fill-caption group-hover:dark:fill-primary"
      }`}
      fill={fill}
    />
  </svg>
);
export default DetailedIcon;
